import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { CandidacyPlacement, HttpResponse } from "@/types";

// Confirms a placement's actual start date from the dashboard task list. The
// backend cascades this (completes the missing-start/confirm-start task, spins
// up check-ins, promotes the candidacy to Employed), so we refetch the
// calendar/tasks data rather than hand-patch the cache.
export function useUpdateSetPlacementStartDate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      companyId,
      jobId,
      id,
      dateStarted,
    }: {
      companyId: string;
      jobId: string;
      id: number;
      dateStarted: string;
    }) => {
      const path = `companies/${companyId}/jobs/${jobId}/placements/${id.toString()}`;
      const res = await guacHttpClient.patch<
        CandidacyPlacement,
        HttpResponse<CandidacyPlacement>
      >(path, { dateStarted });

      return res.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["calendar-and-tasks"],
      });
      // Earnings tracker rows key off dateStarted too
      await queryClient.invalidateQueries({ queryKey: ["staffer-earnings"] });
    },
  });
}
